import { Table } from 'react-bootstrap';
import AccordionCard from '../AccordionCard';

const SerialNumberFormatOld = () => {
  return (
    <>
      <AccordionCard title="Company Record" parent="reqSerialNumAccordion">
        <p className="fs-5 fst-italic mb-1">First record in file is Company Record. </p>
        <Table className="m-0" striped responsive>
          <thead className="fs-4">
            <tr>
              <th>Position</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Position 1</td>
              <td>Always “C” and indicates the mortgage company</td>
            </tr>
            <tr>
              <td>Positions 2 - 10</td>
              <td>I.D. Number given when you set up the companies</td>
            </tr>
            <tr>
              <td>Positions 11 - 29</td>
              <td>Name of Mortgage Company as you entered when you set them up.</td>
            </tr>
            <tr>
              <td>Example</td>
              <td>C123456789NATIONWIDE ADVANTAGE MORTGAGE</td>
            </tr>
          </tbody>
        </Table>
      </AccordionCard>
      <AccordionCard title="Property Record" parent="reqSerialNumAccordion">
        <p className="fs-5 fst-italic mb-1">
          Each Company Record is followed by the Property Record and always begins with a “P”.
        </p>
        <Table className="m-0" striped responsive>
          <thead className="fs-4">
            <tr>
              <th>Position</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Position 1</td>
              <td>Always “P” for Property Record</td>
            </tr>
            <tr>
              <td>Positions 2- 27</td>
              <td>Blank</td>
            </tr>
            <tr>
              <td>Positions 28 - 36</td>
              <td>Property Serial Number</td>
            </tr>
            <tr>
              <td>Positions 37 - 102</td>
              <td>Blank - at this time anything beyond here will be ignored.</td>
            </tr>
            <tr>
              <td>Example:</td>
              <td>
                P 010470003 3970002205192 0001071 <br />P 010700001 3970001935528 0001071
              </td>
            </tr>
          </tbody>
        </Table>
      </AccordionCard>
    </>
  );
};

export default SerialNumberFormatOld;
